module.exports = __webpack_public_path__ + "img/744.d3fde5c2.jpg";